let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6l3oD")).then(() => parcelRequire('7Ig1b'));